/* Product gallery: swipeable slides, thumbnails, full-screen viewer with zoom */
(function () {
  'use strict';
  var g = document.querySelector('[data-gallery]');
  if (!g) return;
  var track = g.querySelector('[data-g-track]');
  if (!track) return;
  var slides = Array.prototype.slice.call(track.querySelectorAll('[data-g-open]'));
  var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-g-thumb]'));
  var countEl = g.querySelector('[data-g-count]');
  var current = 0;

  function goMain(i, smooth) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    setActive(i);
  }
  function setActive(i) {
    current = i;
    if (countEl) countEl.textContent = i + 1;
    thumbs.forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
  }
  var st;
  track.addEventListener('scroll', function () {
    clearTimeout(st);
    st = setTimeout(function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== current) setActive(i);
    }, 60);
  }, { passive: true });
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { goMain(parseInt(t.dataset.gThumb, 10)); });
  });
  var prev = g.querySelector('[data-g-prev]'), next = g.querySelector('[data-g-next]');
  if (prev) prev.addEventListener('click', function () { goMain(current - 1); });
  if (next) next.addEventListener('click', function () { goMain(current + 1); });

  /* ---------- Full-screen viewer ---------- */
  var lb, lbTrack, lbCount, lbIndex = 0, lastFocus;
  function build() {
    lb = document.createElement('div');
    lb.className = 'lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product photos');
    lb.hidden = true;
    var html = '<div class="lb__bar"><span class="lb__count" aria-live="polite"></span>' +
      '<button type="button" class="lb__close" data-lb-close aria-label="Close photos">' +
      '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="lb__track" data-lb-track>';
    slides.forEach(function (s, i) {
      var img = s.querySelector('img');
      var alt = img ? img.alt : '';
      html += '<div class="lb__slide" data-lb-slide><img src="' + s.dataset.full + '" alt="' + alt.replace(/"/g, '&quot;') + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '" draggable="false"></div>';
    });
    html += '</div>';
    if (slides.length > 1) {
      html += '<button type="button" class="lb__arrow lb__arrow--prev" data-lb-prev aria-label="Previous photo">‹</button>' +
        '<button type="button" class="lb__arrow lb__arrow--next" data-lb-next aria-label="Next photo">›</button>';
    }
    html += '<p class="lb__hint">Tap photo to zoom' + (slides.length > 1 ? ' · swipe for more' : '') + '</p>';
    lb.innerHTML = html;
    document.body.appendChild(lb);
    lbTrack = lb.querySelector('[data-lb-track]');
    lbCount = lb.querySelector('.lb__count');

    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    var p = lb.querySelector('[data-lb-prev]'), n = lb.querySelector('[data-lb-next]');
    if (p) p.addEventListener('click', function () { goLb(lbIndex - 1); });
    if (n) n.addEventListener('click', function () { goLb(lbIndex + 1); });

    var lt;
    lbTrack.addEventListener('scroll', function () {
      clearTimeout(lt);
      lt = setTimeout(function () {
        var i = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
        if (i !== lbIndex) { unzoomAll(); setLb(i); }
      }, 60);
    }, { passive: true });

    /* Tap to zoom in at the tapped point; tap again to zoom out. Drag to pan while zoomed. */
    lb.querySelectorAll('[data-lb-slide]').forEach(function (sl) {
      var img = sl.querySelector('img');
      var down = null, moved = false;
      sl.addEventListener('pointerdown', function (e) {
        down = { x: e.clientX, y: e.clientY, sl: sl.scrollLeft, st: sl.scrollTop };
        moved = false;
        if (sl.classList.contains('is-zoomed') && e.pointerType === 'mouse') sl.setPointerCapture(e.pointerId);
      });
      sl.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - down.x, dy = e.clientY - down.y;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
        if (sl.classList.contains('is-zoomed') && e.pointerType === 'mouse') {
          sl.scrollLeft = down.sl - dx; sl.scrollTop = down.st - dy;
        }
      });
      sl.addEventListener('pointerup', function (e) {
        var wasDown = down; down = null;
        if (!wasDown || moved) return;
        if (e.target !== img) { if (!sl.classList.contains('is-zoomed')) close(); return; }
        toggleZoom(sl, img, e);
      });
      sl.addEventListener('pointercancel', function () { down = null; });
    });

    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') goLb(lbIndex + 1);
      else if (e.key === 'ArrowLeft') goLb(lbIndex - 1);
      else if (e.key === 'Tab') {
        var f = lb.querySelectorAll('button');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (!lb.hidden) lbTrack.scrollLeft = lbIndex * lbTrack.clientWidth; });
  }
  function toggleZoom(sl, img, e) {
    if (sl.classList.contains('is-zoomed')) { unzoomAll(); return; }
    var r = img.getBoundingClientRect();
    var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
    sl.classList.add('is-zoomed');
    lb.classList.add('is-zoomed');
    sl.scrollLeft = Math.max(0, img.offsetWidth * fx - sl.clientWidth / 2);
    sl.scrollTop = Math.max(0, img.offsetHeight * fy - sl.clientHeight / 2);
  }
  function unzoomAll() {
    if (!lb) return;
    lb.classList.remove('is-zoomed');
    lb.querySelectorAll('.is-zoomed').forEach(function (s) { s.classList.remove('is-zoomed'); s.scrollLeft = 0; s.scrollTop = 0; });
  }
  function setLb(i) {
    lbIndex = i;
    lbCount.textContent = slides.length > 1 ? (i + 1) + ' / ' + slides.length : '';
    var p = lb.querySelector('[data-lb-prev]'), n = lb.querySelector('[data-lb-next]');
    if (p) p.disabled = i === 0;
    if (n) n.disabled = i === slides.length - 1;
  }
  function goLb(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    unzoomAll();
    lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: 'smooth' });
    setLb(i);
  }
  function open(i) {
    if (!lb) build();
    lastFocus = document.activeElement;
    lb.hidden = false;
    document.documentElement.classList.add('lb-open');
    unzoomAll();
    lbTrack.style.scrollSnapType = 'none';
    lbTrack.scrollLeft = i * lbTrack.clientWidth;
    lbTrack.style.scrollSnapType = '';
    setLb(i);
    lb.querySelector('[data-lb-close]').focus({ preventScroll: true });
  }
  function close() {
    if (!lb || lb.hidden) return;
    unzoomAll();
    lb.hidden = true;
    document.documentElement.classList.remove('lb-open');
    goMain(lbIndex, false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  slides.forEach(function (s, i) {
    s.addEventListener('click', function () { open(i); });
  });
})();
